import { getBooleanFromValue } from '@/global/utils/utils'
import { api } from '@/global/services/api'

const TAB_KEY = 'temperatureSensors'
const TEMPERATURE_SENSORS_DATA_KEY = 'temperature_sensors'
export default {
  data () {
    return {
      temperatureSensorInputTypes: []
    }
  },

  computed: {
    temperatureSensorsConfig () {
      return {
        title: this.$t('base/tracker.temperature_sensors'),
        key: TAB_KEY,
        visible: getBooleanFromValue(this.permissions?.canReadTemperatureSensors),
        onLoad: () => this.onTemperatureSensorsTabLoad(),
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/temperature-sensors`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/temperature-sensors`
          }
        },
        hiddenFormKeys: [
          TEMPERATURE_SENSORS_DATA_KEY
        ],
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.temperature_sensors'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 1,
                fields: [
                  {
                    key: 'temperature_sensors_status',
                    label: this.$t('base/tracker.temperature_sensors_status'),
                    type: 'autocomplete',
                    items: [
                      {
                        id: 1,
                        name: this.$t('base.active')
                      },
                      {
                        id: 0,
                        name: this.$t('base.inactive')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            type: 'dynamic-columns',
            showButtons: false,
            component: this.dynamicColumnsContentComponent,
            key: TEMPERATURE_SENSORS_DATA_KEY,
            display_props: ['temperature_sensor_type_id', 'name'],
            headers: [this.$t('base/tracker.temperature_sensor_type'), this.$t('base/tracker.temperature_sensor_name')],
            fields: [
              {
                key: 'temperature_sensor_type_id',
                type: 'autocomplete',
                items: this.temperatureSensorInputTypes,
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'name',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onTemperatureSensorsTabLoad () {
      try {
        const { data } = await api('base').get('temperature-sensors-input-types')
        if (data?.length) {
          this.temperatureSensorInputTypes = data
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
